'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';
import type { KnowledgeHub } from '@/types';
import { resolveImageUrl } from '@/lib/image';

export const KnowledgeHubArticleView: React.FC<{ article: KnowledgeHub }> = ({ article }) => {
    const { i18n } = useTranslation();
    const title = i18n.language === 'de' && article.title_de ? article.title_de : article.title;
    const body = i18n.language === 'de' && article.body_de ? article.body_de : article.body;
    const topic = i18n.language === 'de' && article.topic_de ? article.topic_de : article.topic;
    const abstract = i18n.language === 'de' && article.abstract_de ? article.abstract_de : article.abstract;
    const imageDescription =
        i18n.language === 'de' && article.image_description_de
            ? article.image_description_de
            : article.image_description;

    return (
        <div className="blog-post">
            <div className="container">
                <article className="post-content" data-testid="content-article">
                    {article.image && (
                        <>
                            <img
                                src={resolveImageUrl(article.image)}
                                alt={title}
                                className="post-image"
                                loading="eager"
                                decoding="async"
                                width={1200}
                                height={675}
                            />
                            {imageDescription && (
                                <p
                                    className="post-image-description"
                                    dangerouslySetInnerHTML={{ __html: imageDescription }}
                                />
                            )}
                        </>
                    )}

                    <h1 className="post-title">{title}</h1>

                    {topic && (
                        <div className="post-meta">
                            <span className="post-date">{topic}</span>
                        </div>
                    )}

                    {abstract && (
                        <div className="post-abstract" dangerouslySetInnerHTML={{ __html: abstract }} />
                    )}
                    <div className="post-body" dangerouslySetInnerHTML={{ __html: body }} />
                </article>
            </div>
        </div>
    );
};
